import type { ActionTemplateSearchResource, StepPackageDeploymentTargetType } from "@octopusdeploy/octopus-server-client";
import { Environment } from "@octopusdeploy/utilities";
export function hidePrereleaseStepPackages(stepPackage: StepPackageDeploymentTargetType | ActionTemplateSearchResource) {
    if (Environment.isInDevelopmentMode()) {
        return true;
    }
    return !stepPackage.Prerelease;
}
